import { render } from "./AmazingTeam.vue?vue&type=template&id=cc67eaa2&scoped=true"
import script from "./AmazingTeam.vue?vue&type=script&lang=js"
export * from "./AmazingTeam.vue?vue&type=script&lang=js"

import "./AmazingTeam.vue?vue&type=style&index=0&id=cc67eaa2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc67eaa2"]])

export default __exports__